<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    [nzTitle]="title"
    [nzWidth]="700"
    [nzFooter]="null"
    nzClassName="custom-modal"
    (nzOnCancel)="close()"
>
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="loading">
            <form nz-form class="date-container" [formGroup]="validateForm" *ngIf="showTaskRange">
                <nz-form-item>
                    <nz-form-control [nzSpan]="16">
                        <nz-range-picker formControlName="taskDate" [nzAllowClear]="false" nzDisabled></nz-range-picker>
                    </nz-form-control>
                </nz-form-item>
            </form>
            <app-project-calendar
                #projectCalendar
                [events]="this.calendarOptions.events"
                (changeRange)="changeRange($event)"
            ></app-project-calendar>
        </nz-spin>
    </ng-container>
</nz-modal>
